export default __webpack_public_path__ + "static/media/logo.0947c55e.png";